<template>
  <form @submit.prevent="submit">
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="modal-card-title">
          <p class="has-text-weight-bold title is-4">Request Date Change</p>
        </div>
      </header>
      <section class="modal-card-body">
        <b-field label="Reason">
          <b-select v-model="reason" expanded>
            <option value="">Select Reason</option>
            <option
              :value="reason.value"
              v-for="reason in $options.reasons"
              :key="reason.value"
            >
              {{ reason.label }}
            </option>
          </b-select>
        </b-field>
        <b-field label="Requested Date">
          <b-datetimepicker
            :datetime-formatter="dateFormatter"
            icon="calendar"
            size="is-small"
            inline
            v-model="requestedDate"
          />
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          Cancel
        </button>
        <button :class="`button is-info ${loading ? 'is-loading' : ''}`">
          Submit
        </button>
      </footer>
    </div>
  </form>
</template>

<script>
import moment from "moment";
import { OrderService } from "@/services/order.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  orderService: OrderService,
  reasons: [
    {
      value:
        "Council directed change of priority or strategic delay to coincide with other works",
      label: "Council directed change"
    },
    {
      value:
        "Challenges in gaining landowner permission (negotiation/consent onto property)",
      label: "Awaiting land owners permission"
    },
    {
      value:
        "Change of intial RFS scope requiring review of delivery timeframes",
      label: "RFS scope change"
    },
    {
      value: "Delay in aquiring third party approvals CARs",
      label: "Third party CARs"
    },
    {
      value: "Delay in aquiring third party approvals (KiwiRail/NZTA)",
      label: "Third party KiwiRail/NZTA"
    },
    {
      value: "Delay in specialist provider delivering service",
      label: "Special service"
    },
    {
      value: "Inclement weather or poor gound conditions impacting delivery",
      label: "Extreme weather"
    },
    {
      value: "Reliance third party service or works completion",
      label: "Third party reliance"
    },
    {
      value: "Significant system, data error or technology failures",
      label: "Technology failure"
    },
    {
      value: "Site unavailable due to other works or events impacting delivery",
      label: "Site not available"
    },
    {
      value: "Storm Event leading to delay in delivery or change in priority",
      label: "Storm event delay"
    },
    {
      value:
        "Third Party Damage (TPD) or reliance third party service or works completion",
      label: "Third party damage"
    },
    {
      value: "Unable to acess property/right of entry or access issues",
      label: "Property access issues"
    },
    {
      value:
        "Unforeseen physical equipment failure resulting in delay to delivery",
      label: "Unforeseen equipment failure"
    },
    {
      value: "Work scope and extend not well specified",
      label: "Work instruction unclear"
    },
    {
      value: "Works require engineer to apply for resource consent",
      label: "Consent required - engineer"
    }
  ],
  props: {
    orderId: {
      type: String,
      required: true
    },
    type: {
      validator: value => {
        return ["start", "finish"].indexOf(value) !== -1;
      },
      required: true
    }
  },
  data: () => ({
    requestedDate: null,
    reason: "",
    loading: false
  }),
  methods: {
    dateFormatter(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    dateParser(date) {
      return moment(date)
        .tz(moment.tz.guess())
        .format();
    },
    async submit() {
      this.loading = true;

      try {
        const order = await this.$options.orderService
          .requestDateChange(this.orderId, {
            startOrFinish: this.type,
            requestedDate: this.dateParser(this.requestedDate),
            dateChangeRequest: this.reason,
            includes: "dateChangeLogs"
          })
          .then(response => JsonDenormalizer.denormalize(response.data));

        this.$buefy.toast.open({
          message: "Date change request has been sent.",
          type: "is-info",
          position: "is-top-right"
        });

        this.$emit("submit", order);
        this.$parent.close();
      } catch (err) {}

      this.loading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderKpi/OrderKpiDateChangeModalRequest.vue